export default __webpack_public_path__ + "static/media/9.44a5377e.png";